<template>
  <div class="editable-field">
    <!-- Display mode -->
    <div v-show="!editing" style="width: 100%">
      <div class="d1">
        <span>
          <slot name="displayValue"></slot>
        </span>
        <v-icon
          @click="startEditing"
          class="pull-right ml-6"
          style="display: inline-block"
          color="grey darken-4"
        >
          mdi-playlist-edit
        </v-icon>
      </div>
    </div>
    
    <!-- Edit mode -->
    <div v-show="editing" class="edit-container">
      <!-- Input field (rendered via slot) -->
      <slot name="editField" :update-value="updateValue"></slot>
      
      <!-- Radio buttons for calculation mode (optional) -->
      <slot name="calculationMode"></slot>
      
      <!-- Action buttons -->
      <div class="d-flex justify-content-center mt-2">
        <v-icon
          @click="cancelEdit"
          class="left-icon-pos pull-left"
          color="red darken-4"
        >
          mdi-marker-cancel
        </v-icon>
        <v-icon
          @click="saveEdit"
          class="left-icon-pos pull-left ml-8"
          color="green darken-4"
        >
          mdi-cloud-check
        </v-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditableField',
  props: {
    fieldType: {
      type: String,
      required: true
    },
    initialValue: {
      required: true
    },
    projectId: {
      required: true
    },
    formatFunction: {
      type: Function,
      default: value => value
    }
  },
  data() {
    return {
      editing: false,
      currentValue: this.initialValue,
      calculationMode: 'non' // Default value
    }
  },
  methods: {
    startEditing() {
      this.editing = true;
      this.$emit('edit-started', this.fieldType, this.projectId);
    },
    cancelEdit() {
      this.editing = false;
      this.currentValue = this.initialValue;
      this.$emit('edit-cancelled', this.fieldType, this.projectId);
    },
    saveEdit() {
      this.$emit('save-value', {
        fieldType: this.fieldType,
        projectId: this.projectId,
        value: this.currentValue,
        calculationMode: this.calculationMode
      });
      this.editing = false;
    },
    updateValue(value) {
      this.currentValue = value;
    },
    setCalculationMode(mode) {
      this.calculationMode = mode;
    }
  }
}
</script>

<style scoped>
.editable-field {
  width: 100%;
}
.d1 {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-end;
}
.edit-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
</style>